import React, { useState } from 'react'
import { FloorMapSpaces } from '@api'
import { Flex } from '@ui'
import ChartSection from 'components/ChartSection'
import { groupBy, keys } from 'lodash'
import { Button } from '@runeffective/evo-design-system'
import typescriptNaturalSort from 'typescript-natural-sort'
import { getColor } from 'components/Reports/config'
import SpaceTypesDialog from './spaceTypesPopup'
import UsageTypesDialog from './usageTypesPopup'
import NeighborhoodDialog from './neighborhoodPopup'

const formatData = (spaces: any, selectedItems: string[]) => {
  const { byId } = spaces
  const items = selectedItems.reduce(
    (result: any, id: string) => (byId[id] ? [...result, byId[id]] : result),
    []
  )
  const grouped = groupBy(items, ({ spaceType }) => spaceType.displayName)

  return keys(grouped)
    .sort((k1, k2) => typescriptNaturalSort(k1, k2))
    .map((key, i) => {
      return {
        key,
        label: key,
        color: `#${getColor(i)}`,
        value: grouped[key].length,
        percent: Math.round((grouped[key].length / items.length) * 100),
      }
    })
}

const SpaceTypesSection = ({
  spaces,
  selectedItems,
}: {
  spaces: FloorMapSpaces
  selectedItems: string[]
}) => {
  const chartData = formatData(spaces, selectedItems)
  const [isSpaceTypeOpen, setisSpaceTypeOpen] = useState(false)
  const [isUsageTypeOpen, setisUsageTypeOpen] = useState(false)
  const [isNeighborhoodOpen, setisNeighborhoodOpen] = useState(false)

  return (
    <div style={{ margin: '10px' }}>
      <ChartSection chartType="donut" colName="" description="" data={chartData} />
      <Flex style={{ width: '100%', margin: '5px' }} direction="row" justify="space-between">
        <Button
          layout="secondary"
          onClick={() => {
            setisSpaceTypeOpen(true)
          }}
          size="small">
          Update space types
        </Button>
        <Button
          layout="secondary"
          onClick={() => {
            setisUsageTypeOpen(true)
          }}
          size="small">
          Update usage types
        </Button>
      </Flex>

      <SpaceTypesDialog
        setisSpaceTypeOpen={setisSpaceTypeOpen}
        isSpaceTypeOpen={isSpaceTypeOpen}
        selectedSpaces={selectedItems}
        data={chartData}
      />

      <UsageTypesDialog
        setisUsageTypeOpen={setisUsageTypeOpen}
        isUsageTypeOpen={isUsageTypeOpen}
        selectedSpaces={selectedItems}
        setisNeighborhoodOpen={setisNeighborhoodOpen}
      />

      <NeighborhoodDialog
        setisNeighborhoodOpen={setisNeighborhoodOpen}
        isNeighborhoodOpen={isNeighborhoodOpen}
        spaces={spaces}
        selectedSpaces={selectedItems}
      />
    </div>
  )
}

export default SpaceTypesSection
